import { SlidersHorizontal } from 'lucide-react'
import SkillTierRow from '../../../components/profile/SkillTierRow'
import { SKILL_TIERS } from '../../../skillTiers'
import DemoFrame from './DemoFrame'

/**
 * Calibrating first, then the four tiers.
 *
 * Leading with calibrating is the point: a new player's first three scored gameweeks show that
 * state and not a tier, and without it on the ladder the calibrating badge on their own profile
 * reads as a bug. It takes the same neutral glyph the profile uses — no tier is claimed yet, so
 * it must not borrow the Rookie sapling.
 */
export default function IntuitionDemo() {
  return (
    <DemoFrame className="rules-demo--tiers">
      <SkillTierRow icon={SlidersHorizontal} name="Calibrating" />
      {SKILL_TIERS.map((tier, i) => {
        const nextTier = SKILL_TIERS[i + 1]
        return (
          <SkillTierRow
            key={tier.name}
            icon={tier.icon}
            name={tier.name}
            range={nextTier ? `${tier.minPct}–${nextTier.minPct}%` : `${tier.minPct}%+`}
            color={tier.textColor}
          />
        )
      })}
    </DemoFrame>
  )
}
